export default {"src":"/_next/static/media/SYF.24dabb64.svg","height":18,"width":18};